import { useContext, useEffect, useMemo, useState, useCallback } from 'react';
import { DEFAULT_LOCALE_CODE } from '../const';
import { CompanyContext } from '../providers/companyProvider';

const useLocales = ( formController ) => {
    const { company } = useContext( CompanyContext );
    const [ descriptionRawHTML, setDescriptionRawHTML ] = useState( '' );
   
    const [ currentLocaleCode, setCurrentLocaleCode ] = useState( DEFAULT_LOCALE_CODE );  
    
    const [ locales, setLocales ] = useState( [] );
    
    useEffect( () => { 
        const newLocale = locales.find( i => i.locale === currentLocaleCode );

        formController.setFieldsValue( { name: newLocale?.name || '' } ); 
        formController.setFieldsValue ( { description: newLocale?.description || '' } );  

        setDescriptionRawHTML( newLocale?.description || '' ); 
    }, [ locales, currentLocaleCode, formController ] );
     
    const handleChangeLocale = useCallback( code => {
        const name = formController.getFieldValue( 'name' );
        const description = formController.getFieldValue( 'description' );

        const updatedLocales = [ ...locales.filter( loc => loc.locale !== currentLocaleCode ), { locale: currentLocaleCode, description, name } ];
         
        setCurrentLocaleCode( code );
        setLocales( updatedLocales );
        
        return updatedLocales;
    }, [ formController, locales, currentLocaleCode ] );
    
    const validateEnglishExists = useCallback( () => {
        const code = company?.defaultLocaleCode || 'en-US';
        const defaultLocale = locales.find( i => i.locale === code );

        if ( defaultLocale && ( defaultLocale.name !== '' && defaultLocale.description !== '' ) ) {
            return true;
        } else {
            return false;
        }
    } );

    return useMemo( () => {
        return [ currentLocaleCode, setLocales, descriptionRawHTML, handleChangeLocale, setCurrentLocaleCode, validateEnglishExists ] ;
    }, [ currentLocaleCode, setLocales, descriptionRawHTML, handleChangeLocale, setCurrentLocaleCode, validateEnglishExists ] );
};

export default useLocales;
